import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-crew-team',
  templateUrl: './crew-team.component.html',
  styleUrls: ['./crew-team.component.sass'],
})
export class CrewTeamComponent implements OnInit {
  constructor(@Inject('$rootScope') public $rootScope) {}

  ngOnInit() {}
}
